// CRM Leads 线索管理 —— 中文 i18n
// 命名空间: app.crm.lead.*

export const zhCN_crm_lead = {
	// 一级菜单 / 二级菜单
	'app.menu.crm': '线索管理',
	'app.menu.crm.lead.template': '线索模板',
	'app.menu.crm.lead.source': '接入渠道',
	'app.menu.crm.lead.rule': '分配规则',
	'app.menu.crm.lead.pool': '手动分配',

	// ===== 模板 =====
	'app.crm.lead.template.title': '线索模板',
	'app.crm.lead.template.detailTitle': '编辑线索模板',
	'app.crm.lead.template.singleton.button.reset': '重置',
	'app.crm.lead.template.singleton.empty': '模板加载失败,请刷新重试',
	'app.crm.lead.template.error.load': '模板加载失败',
	'app.crm.lead.template.table.id': 'ID',
	'app.crm.lead.template.table.name': '模板名',
	'app.crm.lead.template.table.sourceCode': '关联渠道',
	'app.crm.lead.template.table.isDefault': '是否默认',
	'app.crm.lead.template.table.fieldCount': '字段数',
	'app.crm.lead.template.table.createTime': '创建时间',
	'app.crm.lead.template.label.name': '模板名',
	'app.crm.lead.template.label.sourceCode': '关联渠道',
	'app.crm.lead.template.label.isDefault': '是否默认模板',
	'app.crm.lead.template.placeholder.name': '请输入模板名',
	'app.crm.lead.template.placeholder.sourceCode': '不选表示通用模板',
	'app.crm.lead.template.error.fields.empty': '请至少保留一个字段',
	'app.crm.lead.template.error.fields.key.duplicate': '字段标识不可重复:{keys}',
	'app.crm.lead.template.field.key.readonlyHint': '字段标识映射数据库列,不可修改',
	'app.crm.lead.template.field.type.readonlyHint': '字段类型确认后不可修改',
	'app.crm.lead.template.button.copy': '复制',
	'app.crm.lead.template.button.addField': '新增字段',
	'app.crm.lead.template.button.removeField': '删除',
	'app.crm.lead.template.field.key': '字段标识',
	'app.crm.lead.template.field.label': '字段名',
	'app.crm.lead.template.field.type': '类型',
	'app.crm.lead.template.field.module': '所属模块',
	'app.crm.lead.template.field.module.index': '线索主表',
	// moduleCardTitle —— 详情页 / 模板页的"子表"卡片标题(与 module.* 的"域"叫法区分)
	'app.crm.lead.template.field.moduleCardTitle.index': '线索主表',
	'app.crm.lead.template.field.moduleCardTitle.assignment_distribution': '分配归属子表',
	'app.crm.lead.template.field.module.intake': '留资域',
	'app.crm.lead.template.field.module.assignment_distribution': '分配归属子表',
	'app.crm.lead.template.field.module.platform': '平台域',
	'app.crm.lead.template.field.moduleCardTitle.platform': '平台子表',
	'app.crm.lead.template.field.module.follow': '沟通域',
	'app.crm.lead.template.field.moduleCardTitle.follow': '跟进子表',
	'app.crm.lead.template.field.module.collaborate': '协同域',
	'app.crm.lead.template.field.moduleCardTitle.collaborate': '协同子表',
	'app.crm.lead.template.field.module.call': '通话域',
	'app.crm.lead.template.field.moduleCardTitle.call': '通话子表',
	// 子域(父域下的细分数据域:线索主表下细分为 线索/状态/留资/投保/出单/企微/审计;分配归属子表下细分为 分配/归属)
	'app.crm.lead.template.field.subModule.index': '线索域',
	'app.crm.lead.template.field.subModule.audit': '审计域',
	'app.crm.lead.template.field.subModule.intake': '留资域',
	'app.crm.lead.template.field.subModule.insurance': '投保域',
	'app.crm.lead.template.field.subModule.status': '状态域',
	'app.crm.lead.template.field.subModule.order': '出单域',
	'app.crm.lead.template.field.subModule.wecom': '企微域',
	'app.crm.lead.template.field.subModule.distribution': '分配域',
	'app.crm.lead.template.field.subModule.assignment': '归属域',
	'app.crm.lead.template.field.module.customCreate': '+ 新增模块',

	// 选项配置（select / multiselect 字段维护 {value, label} 列表）
	'app.crm.lead.template.field.options': '选项配置',
	'app.crm.lead.template.button.options': '配置',
	'app.crm.lead.template.modal.options.title': '配置选项',
	'app.crm.lead.template.modal.options.tip': '维护 value 与显示名的映射,运行时按 value 查 label 渲染。空行会被忽略。',
	'app.crm.lead.template.modal.options.column.value': '值',
	'app.crm.lead.template.modal.options.column.label': '显示名',
	'app.crm.lead.template.modal.options.addRow': '新增选项',
	'app.crm.lead.template.modal.options.empty': '暂无选项,点击下方"新增选项"开始配置',
	'app.crm.lead.template.modal.options.error.empty': '值不可为空',
	'app.crm.lead.template.modal.options.error.duplicate': '值不可重复',
	'app.crm.lead.template.modal.createModule.title': '新增模块',
	'app.crm.lead.template.modal.createModule.label': '模块名',
	'app.crm.lead.template.modal.createModule.placeholder': '请输入模块名,如 industry',
	'app.crm.lead.template.modal.createModule.confirm': '确定新增',
	'app.crm.lead.template.modal.createModule.success': '模块已新增',
	'app.crm.lead.template.error.module.name.empty': '模块名不可为空',
	'app.crm.lead.template.error.module.name.duplicate': '模块名已存在',
	'app.crm.lead.template.field.visible': '显示',
	'app.crm.lead.template.field.searchable': '可搜索',
	'app.crm.lead.template.field.section.title': '字段定义',
	'app.crm.lead.template.field.searchPlaceholder': '搜索字段标识 / 字段名',
	'app.crm.lead.template.field.filter.all': '全部模块',
	'app.crm.lead.template.field.totalCount': '共 {count} / {total} 个字段',
	'app.crm.lead.template.field.newLabel': '新字段',
	'app.crm.lead.template.field.empty': '暂无字段,点击右上角"新增字段"开始添加',
	'app.crm.lead.template.button.deleteField': '删除',
	'app.crm.lead.template.button.restoreField': '恢复',
	'app.crm.lead.template.fieldType.text': '文本',
	'app.crm.lead.template.fieldType.phone': '手机号',
	'app.crm.lead.template.fieldType.email': '邮箱',
	'app.crm.lead.template.fieldType.number': '数字',
	'app.crm.lead.template.fieldType.date': '日期',
	'app.crm.lead.template.fieldType.select': '下拉单选',
	'app.crm.lead.template.fieldType.multiselect': '下拉多选',
	'app.crm.lead.template.fieldType.textarea': '多行文本',
	'app.crm.lead.template.confirm.delete.hasHistoryTitle': '该模板已被线索数据引用',
	'app.crm.lead.template.confirm.delete.hasHistoryContent': '删除将导致历史线索字段值丢失,确认删除?',
	'app.crm.lead.template.confirm.delete.unsavedTitle': '删除未保存字段?',
	'app.crm.lead.template.confirm.delete.unsavedContent': '该字段尚未保存,删除后无法恢复,确认?',

	// ===== 渠道 =====
	'app.crm.lead.source.title': '接入配置',
	'app.crm.lead.source.detailTitle': '编辑接入配置',
	'app.crm.lead.source.detail.tab.basic': '基础信息',
	'app.crm.lead.source.detail.tab.mapping': '字段映射',
	'app.crm.lead.source.step.basic': '基础信息',
	'app.crm.lead.source.step.mapping': '字段映射',
	'app.crm.lead.source.button.next': '下一步',
	'app.crm.lead.source.button.back': '上一步',
	'app.crm.lead.source.detail.mapping.title': '本渠道的字段映射规则',
	'app.crm.lead.source.detail.mapping.targetTemplate': '目标模板:{name}',
	'app.crm.lead.source.detail.mapping.empty': '暂无映射规则,点击右上角"新增规则"添加',
	'app.crm.lead.source.table.id': 'ID',
	'app.crm.lead.source.table.name': '渠道名',
	'app.crm.lead.source.table.type': '类型',
	'app.crm.lead.source.table.callbackUrl': '接入地址',
	'app.crm.lead.source.table.createTime': '创建时间',
	'app.crm.lead.source.label.name': '配置名',
	'app.crm.lead.source.label.type': '渠道类型',
	'app.crm.lead.source.label.callbackUrl': '接入地址',
	'app.crm.lead.source.label.secret': '密钥',
	'app.crm.lead.source.label.description': '描述',
	'app.crm.lead.source.placeholder.name': '请输入配置名',
	'app.crm.lead.source.placeholder.description': '可选',
	'app.crm.lead.source.error.name.required': '配置名不可为空',
	'app.crm.lead.source.hint.callbackUrl.auto': '接入地址由服务端按渠道 ID 自动生成,无需手动配置;保存后即可使用。',
	'app.crm.lead.source.type.douyin': '抖音',
	'app.crm.lead.source.type.xiaohongshu': '小红书',
	'app.crm.lead.source.type.wechat_work': '企业微信',
	'app.crm.lead.source.type.manual': '手动录入',
	'app.crm.lead.source.type.web': '网页',
	'app.crm.lead.source.type.other': '其他',
	'app.crm.lead.source.button.viewSecret': '查看密钥',
	'app.crm.lead.source.button.hideSecret': '隐藏密钥',
	'app.crm.lead.source.button.copyUrl': '复制地址',

	// ===== 接入配置 - 画布（详情页 = 画布） =====
	'app.crm.lead.source.detail.title.create': '新建接入配置',
	'app.crm.lead.source.detail.title.edit': '编辑接入配置',
	'app.crm.lead.integration.node.dataSource': '外部回调',
	'app.crm.lead.integration.node.standardTable': '线索主表',
	'app.crm.lead.integration.node.platformTable': '平台子表',
	'app.crm.lead.integration.mappingCount': '条映射',
	'app.crm.lead.integration.hint': '拖拽连线建立映射 · 选中后点删除或按 Backspace 断开',
	'app.crm.lead.integration.button.addExternalField': '新增外部字段',
	'app.crm.lead.integration.confirm.switchType.title': '切换渠道类型?',
	'app.crm.lead.integration.confirm.switchType.content':
		'切换渠道类型会重置当前数据源字段,已有的连线也会被清空,是否继续?',
	'app.crm.lead.integration.field.modal.title': '新增外部字段',
	'app.crm.lead.integration.field.label': '字段路径',
	'app.crm.lead.integration.field.displayName': '显示名',
	'app.crm.lead.integration.field.type': '类型',
	'app.crm.lead.integration.field.sample': '示例值',
	'app.crm.lead.integration.field.error.empty': '字段路径与显示名均不可为空',
	'app.crm.lead.integration.field.error.duplicate': '字段路径已存在,请使用其他路径',

	// 从 JSON 导入
	'app.crm.lead.integration.button.importFromJson': '从 JSON 导入',
	'app.crm.lead.integration.json.modal.title': '从 JSON 样本生成外部字段',
	'app.crm.lead.integration.json.hint':
		'粘贴一段外部回调的 JSON 样本(可包含嵌套对象),系统会自动拍扁成字段路径并推断类型。',
	'app.crm.lead.integration.json.button.parse': '解析预览',
	'app.crm.lead.integration.json.preview.title': '已识别 {count} 个字段',
	'app.crm.lead.integration.json.mode.replace': '替换现有',
	'app.crm.lead.integration.json.mode.append': '追加',
	'app.crm.lead.integration.json.error.empty': '请粘贴 JSON 文本',
	'app.crm.lead.integration.json.error.parse': 'JSON 解析失败,请检查格式',
	'app.crm.lead.integration.json.error.emptyFields': '未识别到任何字段(可能 JSON 是空对象)',
	'app.crm.lead.integration.json.error.parseFirst': '请先点击"解析预览"',
	'app.crm.lead.integration.json.success.imported': '已导入 {count} 个字段',

	// 连线样式
	'app.crm.lead.integration.edge.type': '连线样式',
	'app.crm.lead.integration.edge.type.default': '曲线',
	'app.crm.lead.integration.edge.type.straight': '直线',
	'app.crm.lead.integration.edge.type.step': '折线',
	'app.crm.lead.integration.edge.type.smoothstep': '平滑折线',
	'app.crm.lead.integration.edge.animated': '动效',
	'app.crm.lead.integration.button.deleteEdge': '删除连线',

	// ===== 映射 =====
	'app.crm.lead.mapping.title': '字段映射',
	'app.crm.lead.mapping.detailTitle': '编辑字段映射',
	'app.crm.lead.mapping.table.id': 'ID',
	'app.crm.lead.mapping.table.sourceName': '渠道',
	'app.crm.lead.mapping.table.templateName': '模板',
	'app.crm.lead.mapping.table.ruleCount': '规则数',
	'app.crm.lead.mapping.table.createTime': '创建时间',
	'app.crm.lead.mapping.label.sourceId': '渠道',
	'app.crm.lead.mapping.label.templateId': '模板',
	'app.crm.lead.mapping.label.externalField': '外部字段路径',
	'app.crm.lead.mapping.label.externalSample': '外部示例值',
	'app.crm.lead.mapping.label.internalField': '内部字段',
	'app.crm.lead.mapping.label.transform': '转换方式',
	'app.crm.lead.mapping.label.expression': '表达式',
	'app.crm.lead.mapping.label.defaultValue': '默认值',
	'app.crm.lead.mapping.label.remark': '备注',
	'app.crm.lead.mapping.placeholder.externalField': '如 user.phone',
	'app.crm.lead.mapping.placeholder.expression': '正则或 JSONPath',
	'app.crm.lead.mapping.placeholder.internalField': '请选择模板字段',
	'app.crm.lead.mapping.transform.direct': '直接映射',
	'app.crm.lead.mapping.transform.regex': '正则提取',
	'app.crm.lead.mapping.transform.jsonpath': 'JSONPath',
	'app.crm.lead.mapping.transform.default': '取默认值',
	'app.crm.lead.mapping.transform.constant': '常量填充',
	'app.crm.lead.mapping.button.addRule': '新增规则',
	'app.crm.lead.mapping.button.testMapping': '测试映射',
	'app.crm.lead.mapping.testTitle': '测试映射',
	'app.crm.lead.mapping.testInputLabel': '外部回调 JSON',
	'app.crm.lead.mapping.testOutputLabel': '映射后内部数据',
	'app.crm.lead.mapping.testInputPlaceholder': '粘贴一段外部回调 JSON...',
	'app.crm.lead.mapping.testEmpty': '请输入 JSON 后查看映射结果',
	'app.crm.lead.mapping.testRun': '运行映射',
	'app.crm.lead.mapping.testClear': '清空',
	'app.crm.lead.mapping.error.externalField.required': '外部字段路径不可为空',
	'app.crm.lead.mapping.error.internalField.required': '内部字段不可为空',

	// ===== 规则 =====
	'app.crm.lead.rule.title': '分配规则',
	'app.crm.lead.rule.detailTitle': '编辑分配规则',
	'app.crm.lead.rule.table.id': 'ID',
	'app.crm.lead.rule.table.sourceName': '渠道',
	'app.crm.lead.rule.table.name': '规则名',
	'app.crm.lead.rule.table.strategy': '分配策略',
	'app.crm.lead.rule.table.createTime': '创建时间',
	'app.crm.lead.rule.label.sourceId': '渠道',
	'app.crm.lead.rule.label.name': '规则名',
	'app.crm.lead.rule.label.strategy': '分配策略',
	'app.crm.lead.rule.label.assigneeIds': '指定人员',
	'app.crm.lead.rule.label.deptId': '所属部门',
	'app.crm.lead.rule.label.weights': '人员权重',
	'app.crm.lead.rule.placeholder.name': '请输入规则名',
	'app.crm.lead.rule.placeholder.assignee': '请选择人员',
	'app.crm.lead.rule.placeholder.weightAccount': '请选择人员',
	'app.crm.lead.rule.strategy.assign': '指定人员',
	'app.crm.lead.rule.strategy.round_robin': '按部门轮询',
	'app.crm.lead.rule.strategy.weight': '按权重分配',
	'app.crm.lead.rule.strategy.public_pool': '进入公共池',
	'app.crm.lead.rule.strategyDesc.assign': '多选时按人员 ID 顺序轮询,每次保存后从第一个人重新开始',
	'app.crm.lead.rule.strategyDesc.round_robin': '部门内人员轮流分配',
	'app.crm.lead.rule.strategyDesc.weight': '按权重百分比分配,所有权重之和应为 100%',
	'app.crm.lead.rule.strategyDesc.public_pool': '进入公共线索池,等待分配',
	'app.crm.lead.rule.publicPoolHint': '公共线索池 (固定 1 个)',
	'app.crm.lead.rule.button.addWeight': '新增权重项',
	'app.crm.lead.rule.error.name.required': '规则名不可为空',
	'app.crm.lead.rule.error.assignee.required': '请至少指定一位人员',
	'app.crm.lead.rule.error.dept.required': '请选择部门',
	'app.crm.lead.rule.error.weights.required': '请配置权重',
	'app.crm.lead.rule.weight.value': '权重',
	'app.crm.lead.rule.button.configRule': '配置规则',
	'app.crm.lead.rule.button.viewLeads': '查看线索',
	'app.crm.lead.rule.sheet.title': '规则下的线索',
	'app.crm.lead.rule.sheet.sourceHint': '渠道:{name}',
	'app.crm.lead.rule.sheet.empty': '该规则下暂无线索',

	// ===== 线索池 =====
	'app.crm.lead.pool.title': '线索池',

	// ===== 清单 =====
	'app.crm.lead.list.title': '线索清单',
	'app.crm.lead.list.search.poolOwner': '所属线索池',
	'app.crm.lead.list.search.poolOwner.public': '公共线索池',
	'app.crm.lead.list.search.poolOwner.unassigned': '未分配线索池',
	'app.crm.lead.list.search.poolOwner.salesRep': '员工',
	'app.crm.lead.list.table.name': '姓名',
	'app.crm.lead.list.table.phone': '手机号',
	'app.crm.lead.list.table.source': '渠道',
	'app.crm.lead.list.table.remark': '备注',
	'app.crm.lead.list.table.follower': '跟进人',
	'app.crm.lead.list.table.owner': '主理人',
	'app.crm.lead.list.table.updateTime': '最后编辑时间',
	'app.crm.lead.list.table.detail': '详情',
	'app.crm.lead.list.empty': '没有匹配的线索',
	'app.crm.lead.pool.poolOption.public': '公共线索池',
	'app.crm.lead.pool.poolOption.unassigned': '未分配线索池',
	'app.crm.lead.pool.label.poolTypes': '所属线索池',
	'app.crm.lead.pool.placeholder.poolTypes': '请选择(可多选)',
	'app.crm.lead.pool.table.id': 'ID',
	'app.crm.lead.pool.table.name': '客户名',
	'app.crm.lead.pool.table.phone': '手机号',
	'app.crm.lead.pool.table.sourceName': '来源',
	'app.crm.lead.pool.table.status': '状态',
	'app.crm.lead.pool.table.ownerName': '负责人',
	'app.crm.lead.pool.table.followCount': '跟进数',
	'app.crm.lead.pool.table.lastFollowTime': '最近跟进',
	'app.crm.lead.pool.table.createTime': '创建时间',
	'app.crm.lead.pool.label.name': '客户名',
	'app.crm.lead.pool.label.phone': '手机号',
	'app.crm.lead.pool.label.sourceCode': '来源',
	'app.crm.lead.pool.label.status': '状态',
	'app.crm.lead.pool.label.createTime': '创建时间',
	'app.crm.lead.pool.placeholder.name': '按客户名查询',
	'app.crm.lead.pool.placeholder.phone': '按手机号查询',
	'app.crm.lead.pool.button.create': '新建线索',
	'app.crm.lead.pool.button.batchAssign': '批量分配',
	'app.crm.lead.pool.button.release': '释放到池',
	'app.crm.lead.pool.button.grab': '认领',
	'app.crm.lead.pool.button.assign': '分配',
	'app.crm.lead.pool.button.detail': '详情',
	'app.crm.lead.pool.button.call': '一键双呼',
	'app.crm.lead.pool.button.order': '出单登记',
	'app.crm.lead.pool.confirm.batchAssignTitle': '批量分配',
	'app.crm.lead.pool.confirm.batchAssignContent': '请选择要分配给的销售',
	'app.crm.lead.pool.confirm.release.title': '确认释放到公共池?',
	'app.crm.lead.pool.confirm.release.content': '释放后该线索将进入公共线索池,他人可认领',
	'app.crm.lead.pool.success.release': '已释放到公共池',
	'app.crm.lead.pool.success.grab': '认领成功',
	'app.crm.lead.pool.success.assign': '已分配给',
	'app.crm.lead.pool.warning.noSelection': '请先勾选要操作的线索',
	'app.crm.lead.pool.warning.pickAssignee': '请选择分配目标',
	'app.crm.lead.pool.modal.assign.title': '分配线索',
	'app.crm.lead.pool.modal.assign.target': '目标线索',
	'app.crm.lead.pool.modal.assign.assignee': '分配给',
	'app.crm.lead.pool.modal.batchAssign.title': '批量分配线索',
	'app.crm.lead.pool.modal.batchAssign.target': '已选线索数',
	'app.crm.lead.pool.success.batchAssign': '批量分配完成',
	'app.crm.lead.pool.success.batchAssignCount': '成功 {ok} 条 / 共 {total} 条',
	'app.crm.lead.pool.assign.targetPlaceholder': '请选择分配目标',
	'app.crm.lead.pool.detailTitle.create': '新建线索',
	'app.crm.lead.pool.detailTitle.edit': '编辑线索',
	'app.crm.lead.pool.detailTitle.view': '线索详情',
	'app.crm.lead.pool.status.new': '新线索',
	'app.crm.lead.pool.status.contacted': '已联系',
	'app.crm.lead.pool.status.qualified': '已认证',
	'app.crm.lead.pool.status.converted': '已转化',
	'app.crm.lead.pool.status.lost': '已流失',
	'app.crm.lead.pool.status.invalid': '无效',

	// ===== 详情 =====
	'app.crm.lead.detail.title': '线索详情',
	'app.crm.lead.detail.tab.basic': '基础信息',
	'app.crm.lead.detail.tab.follow': '跟进记录',
	'app.crm.lead.detail.tab.assign': '分配历史',
	'app.crm.lead.detail.tab.call': '通话记录',
	'app.crm.lead.detail.tab.order': '出单记录',
	'app.crm.lead.detail.tab.followPlan': '跟进计划',
	'app.crm.lead.detail.tab.changeLog': '变更轨迹',
	'app.crm.lead.detail.section.basic': '基础信息',
	'app.crm.lead.detail.section.oceanengine': '巨量引擎',
	'app.crm.lead.detail.section.follow': '跟进记录',
	'app.crm.lead.detail.section.assign': '分配历史',
	'app.crm.lead.detail.section.custom': '自定义字段',
	// 业务域（Phase 1:view 模式）
	'app.crm.lead.detail.section.customerInfo': '客户资料',
	'app.crm.lead.detail.section.customerInfo.basic': '基础信息',
	'app.crm.lead.detail.section.customerInfo.intake': '留资信息',
	'app.crm.lead.detail.section.assignmentDistribution': '归属分配',
	'app.crm.lead.detail.assignment.cardTitle': '归属',
	'app.crm.lead.detail.distribution.cardTitle': '分配',

	// 索引域字段
	'app.crm.lead.detail.index.field.leadId': '线索唯一ID',
	'app.crm.lead.detail.index.field.leadSource': '线索来源',
	'app.crm.lead.detail.index.field.oneId': 'one_id',
	'app.crm.lead.detail.index.field.liscustomerno': '客户号',
	'app.crm.lead.detail.index.field.bkphone': '备用联系方式',
	'app.crm.lead.detail.index.field.wechat': '微信号',
	'app.crm.lead.detail.index.field.qq': 'QQ号',
	'app.crm.lead.detail.index.field.unionId': 'union_id',
	'app.crm.lead.detail.index.field.platformNickname': '平台昵称',
	'app.crm.lead.detail.index.leadSource.api': '接口创建',
	'app.crm.lead.detail.index.leadSource.manual': '人工创建',
	'app.crm.lead.detail.index.leadSource.import': '批量导入',

	// 留资域字段
	'app.crm.lead.detail.intake.field.leaveTime': '留资时间',
	'app.crm.lead.detail.intake.field.leaveType': '留资类型',
	'app.crm.lead.detail.intake.field.leaveTags': '留资标签',
	'app.crm.lead.detail.intake.field.contactTime': '联系时间',
	'app.crm.lead.detail.intake.field.leaveRemark': '留资备注',
	'app.crm.lead.detail.intake.field.importBatchNo': '导入批次号',
	'app.crm.lead.detail.intake.leaveType.phone': '电话',
	'app.crm.lead.detail.intake.leaveType.wechat': '微信',
	'app.crm.lead.detail.intake.leaveType.qq': 'QQ',
	'app.crm.lead.detail.intake.leaveType.wechat_work': '企微好友',

	// 归属域字段
	'app.crm.lead.detail.assignment.field.bizChannel': '业务渠道',
	'app.crm.lead.detail.assignment.field.branch': '分公司',
	'app.crm.lead.detail.assignment.field.ownerName': '主理人',
	'app.crm.lead.detail.assignment.field.preScreenAssistant': '初筛助理',
	'app.crm.lead.detail.assignment.field.leadOwner': '线索所属人',
	'app.crm.lead.detail.assignment.bizChannel.individual': '个险',
	'app.crm.lead.detail.assignment.bizChannel.broker': '经代',
	'app.crm.lead.detail.assignment.bizChannel.online': '网销',
	'app.crm.lead.detail.assignment.bizChannel.bank': '银保',

	// 分配域字段
	'app.crm.lead.detail.distribution.field.distributeMode': '分配方式',
	'app.crm.lead.detail.distribution.field.distributeBy': '分配人',
	'app.crm.lead.detail.distribution.field.distributeTime': '分配时间',
	'app.crm.lead.detail.distribution.field.distributeCount': '分配次数',
	'app.crm.lead.detail.distribution.mode.direct': '直接下发',
	'app.crm.lead.detail.distribution.mode.preScreen': '初筛后下发',
	'app.crm.lead.detail.distribution.history.title': '分配历史',
	'app.crm.lead.detail.distribution.history.expandAll': '查看更多 ({n})',
	'app.crm.lead.detail.distribution.history.collapse': '收起',

	// 内联编辑
	'app.crm.lead.detail.button.edit': '编辑',
	'app.crm.lead.detail.editModal.title': '编辑字段',
	'app.crm.lead.detail.editModal.success': '保存成功',
	'app.crm.lead.detail.editModal.cancel': '取消',
	'app.crm.lead.detail.editModal.save': '保存',
	'app.crm.lead.detail.editModal.confirmDiscardTitle': '关闭后未保存的内容会丢失，确认？',
	'app.crm.lead.detail.editModal.confirmDiscardContent': '当前编辑未保存',
	'app.crm.lead.detail.follow.empty': '暂无跟进记录',
	'app.crm.lead.detail.assign.empty': '暂无分配记录',
	'app.crm.lead.detail.call.empty': '暂无通话记录',
	'app.crm.lead.detail.call.field.leadId': '线索唯一ID',
	'app.crm.lead.detail.call.field.callId': '通话唯一ID',
	'app.crm.lead.detail.call.field.callTime': '呼叫时间',
	'app.crm.lead.detail.call.field.callType': '呼叫类型',
	'app.crm.lead.detail.call.field.caller': '主叫号码',
	'app.crm.lead.detail.call.field.callee': '被叫号码',
	'app.crm.lead.detail.call.field.receiverRole': '接听人员角色',
	'app.crm.lead.detail.call.field.receiver': '接听人员',
	'app.crm.lead.detail.call.field.answerStatus': '接听状态',
	'app.crm.lead.detail.call.field.ringDuration': '振铃时长',
	'app.crm.lead.detail.call.field.callDuration': '通话时长',
	'app.crm.lead.detail.call.field.hangupParty': '挂断方',
	'app.crm.lead.detail.call.field.customerLocation': '客户号码归属地',
	'app.crm.lead.detail.call.field.missedReason': '未接原因',
	'app.crm.lead.detail.call.field.remark': '通话备注',
	'app.crm.lead.detail.call.field.recording': '录音文件',
	'app.crm.lead.detail.call.callType.outbound': '外呼',
	'app.crm.lead.detail.call.callType.inbound': '呼入',
	'app.crm.lead.detail.call.answerStatus.answered': '已接听',
	'app.crm.lead.detail.call.answerStatus.missed': '未接听',
	'app.crm.lead.detail.call.answerStatus.voicemail': '语音信箱',
	'app.crm.lead.detail.call.answerStatus.rejected': '已拒接',
	'app.crm.lead.detail.call.hangupParty.caller': '主叫挂断',
	'app.crm.lead.detail.call.hangupParty.callee': '被叫挂断',
	'app.crm.lead.detail.call.hangupParty.system': '系统挂断',
	'app.crm.lead.detail.call.receiverRole.sales': '销售',
	'app.crm.lead.detail.call.receiverRole.service': '客服',
	'app.crm.lead.detail.call.receiverRole.ai': 'AI坐席',
	'app.crm.lead.detail.call.missedReason.busy': '用户忙',
	'app.crm.lead.detail.call.missedReason.no_answer': '无人接听',
	'app.crm.lead.detail.call.missedReason.rejected': '拒接',
	'app.crm.lead.detail.call.missedReason.power_off': '已关机',
	'app.crm.lead.detail.call.missedReason.out_of_service': '不在服务区',
	'app.crm.lead.detail.call.durationFormat': '{m}分{s}秒',
	'app.crm.lead.detail.call.recording.play': '播放录音',
	'app.crm.lead.detail.order.empty': '暂无出单记录',
	'app.crm.lead.detail.order.section.basic': '基础信息',
	'app.crm.lead.detail.order.section.saleArea': '销售信息',
	'app.crm.lead.detail.order.section.saleApply': '投保信息',
	'app.crm.lead.detail.order.section.salePay': '缴费信息',
	'app.crm.lead.detail.order.section.convert': '转化与协同',
	'app.crm.lead.detail.order.section.review': '总部复核',
	'app.crm.lead.detail.order.section.branchReview': '分公司复核',
	'app.crm.lead.detail.order.section.reviewArea': '复核信息',
	'app.crm.lead.detail.order.field.policyStatus': '保单状态',
	'app.crm.lead.detail.order.field.applyDate': '投保日期',
	'app.crm.lead.detail.order.field.effectiveDate': '生效日期',
	'app.crm.lead.detail.order.field.policyNo': '保单号',
	'app.crm.lead.detail.order.field.applicant': '投保人',
	'app.crm.lead.detail.order.field.insured': '被保人',
	'app.crm.lead.detail.order.field.productCode': '成交产品',
	'app.crm.lead.detail.order.field.branchCompany': '分公司',
	'app.crm.lead.detail.order.field.signBy': '签单人姓名',
	'app.crm.lead.detail.order.field.payType': '交费类型',
	'app.crm.lead.detail.order.field.premium': '当期保费',
	'app.crm.lead.detail.order.field.payYears': '缴费期限(年)',
	'app.crm.lead.detail.order.field.converterName': '转化人员',
	'app.crm.lead.detail.order.field.collaborationNote': '协同情况',
	'app.crm.lead.detail.order.field.reviewerName': '复核人',
	'app.crm.lead.detail.order.field.reviewStatus': '复核状态',
	'app.crm.lead.detail.order.field.reviewTime': '复核时间',
	'app.crm.lead.detail.order.field.reviewBasis': '复核依据',
	'app.crm.lead.detail.order.field.branchReviewerName': '分公司复核人',
	'app.crm.lead.detail.order.field.branchReviewStatus': '分公司复核状态',
	'app.crm.lead.detail.order.field.branchReviewTime': '分公司复核时间',
	'app.crm.lead.detail.order.policyStatus.pending': '待生效',
	'app.crm.lead.detail.order.policyStatus.active': '已生效',
	'app.crm.lead.detail.order.policyStatus.expired': '已失效',
	'app.crm.lead.detail.order.policyStatus.lapsed': '已失效',
	'app.crm.lead.detail.order.policyStatus.surrendered': '已退保',
	'app.crm.lead.detail.order.policyStatus.rejected': '已拒保',
	'app.crm.lead.detail.order.payType.single': '趸交',
	'app.crm.lead.detail.order.payType.yearly': '年交',
	'app.crm.lead.detail.order.payType.monthly': '月交',
	'app.crm.lead.detail.order.payType.quarterly': '季交',
	'app.crm.lead.detail.order.reviewStatus.pending': '待复核',
	'app.crm.lead.detail.order.reviewStatus.approved': '已通过',
	'app.crm.lead.detail.order.reviewStatus.rejected': '已驳回',
	'app.crm.lead.detail.order.reviewStatus.returned': '已退回',
	'app.crm.lead.detail.followPlan.empty': '暂无跟进计划',
	'app.crm.lead.detail.followPlan.create': '新建跟进计划',
	'app.crm.lead.detail.followPlan.field.leadId': '线索唯一ID',
	'app.crm.lead.detail.followPlan.field.id': '跟进计划ID',
	'app.crm.lead.detail.followPlan.field.follower': '跟进人',
	'app.crm.lead.detail.followPlan.field.planType': '跟进内容类型',
	'app.crm.lead.detail.followPlan.field.planDate': '跟进日期',
	'app.crm.lead.detail.followPlan.field.planTime': '跟进时间',
	'app.crm.lead.detail.followPlan.field.remindBefore': '提醒时间',
	'app.crm.lead.detail.followPlan.field.createTime': '创建时间',
	'app.crm.lead.detail.followPlan.field.content': '跟进内容',
	'app.crm.lead.detail.followPlan.planType.first_contact': '首次沟通',
	'app.crm.lead.detail.followPlan.planType.concept_comm': '理念沟通',
	'app.crm.lead.detail.followPlan.planType.plan_making': '计划书制定',
	'app.crm.lead.detail.followPlan.planType.plan_presentation': '计划书讲解',
	'app.crm.lead.detail.followPlan.planType.silence_activate': '沉默线索激活',
	'app.crm.lead.detail.followPlan.remindBefore.5': '提前 5 分钟',
	'app.crm.lead.detail.followPlan.remindBefore.10': '提前 10 分钟',
	'app.crm.lead.detail.followPlan.form.error.planDate': '跟进日期必须大于等于当前日期',
	'app.crm.lead.detail.followPlan.form.error.planDateRequired': '请选择跟进日期',
	'app.crm.lead.detail.followPlan.form.error.planTypeRequired': '请选择跟进内容类型',
	'app.crm.lead.detail.followPlan.form.error.contentRequired': '请填写跟进内容',
	'app.crm.lead.detail.followPlan.creatorFixed': '创建人(不可变更)',
	'app.crm.lead.detail.changeLog.viewDetail': '查看详情',
	'app.crm.lead.detail.changeLog.empty': '暂无变更记录',
	'app.crm.lead.detail.changeLog.field.operateTime': '操作时间',
	'app.crm.lead.detail.changeLog.field.operator': '变更人',
	'app.crm.lead.detail.changeLog.field.changeType': '操作类型',
	'app.crm.lead.detail.changeLog.field.fieldName': '变更字段',
	'app.crm.lead.detail.changeLog.field.module': '所属主域',
	'app.crm.lead.detail.changeLog.field.subModule': '所属子域',
	'app.crm.lead.detail.changeLog.field.item': '变更项目',
	'app.crm.lead.detail.changeLog.field.moreItems': '等 {n} 项',
	'app.crm.lead.detail.changeLog.field.oldValue': '变更前',
	'app.crm.lead.detail.changeLog.field.newValue': '变更后',
	'app.crm.lead.detail.changeLog.field.ip': '操作 IP',
	'app.crm.lead.detail.changeLog.field.remark': '备注',
	'app.crm.lead.detail.changeLog.filter.domain': '全部主域',
	'app.crm.lead.detail.changeLog.diff.arrow': '→',
	'app.crm.lead.detail.changeLog.changeType.create': '创建',
	'app.crm.lead.detail.changeLog.changeType.edit': '编辑',
	'app.crm.lead.detail.changeLog.changeType.status': '状态变更',
	'app.crm.lead.detail.changeLog.changeType.assign': '分配',
	'app.crm.lead.detail.changeLog.changeType.release': '释放',
	'app.crm.lead.detail.changeLog.changeType.field_update': '字段更新',
	'app.crm.lead.detail.changeLog.changeType.delete': '删除',
	'app.crm.lead.detail.changeLog.changeType.restore': '恢复',
	'app.h5.tab.leads': '线索',
	'app.h5.tab.plans': '计划',
	'app.h5.tab.me': '我的',
	'app.crm.lead.detail.follow.action.call': '电话',
	'app.crm.lead.detail.follow.action.message': '短信',
	'app.crm.lead.detail.follow.action.note': '备注',
	'app.crm.lead.detail.follow.action.visit': '拜访',
	'app.crm.lead.detail.assign.action.assign': '分配',
	'app.crm.lead.detail.assign.action.release': '释放',
	'app.crm.lead.detail.assign.action.grab': '认领',
	'app.crm.lead.detail.call.title': '一键双呼',
	'app.crm.lead.detail.call.dialing': '呼叫中...',
	'app.crm.lead.detail.call.connected': '已接通',
	'app.crm.lead.detail.call.talking': '通话中',
	'app.crm.lead.detail.call.ended': '通话已结束',
	'app.crm.lead.detail.call.callee': '被叫号码',
	'app.crm.lead.detail.call.caller': '您的接听号码',
	'app.crm.lead.detail.call.duration': '通话时长',
	'app.crm.lead.detail.call.hangup': '挂断',
	'app.crm.lead.detail.call.tip': '外呼集成待接入,目前为占位演示',
	'app.crm.lead.detail.order.title': '出单登记',
	'app.crm.lead.detail.order.leadInfo': '客户信息',
	'app.crm.lead.detail.order.product': '产品',
	'app.crm.lead.detail.order.amount': '出单金额',
	'app.crm.lead.detail.order.policyNo': '保单号',
	'app.crm.lead.detail.order.effectiveDate': '生效日期',
	'app.crm.lead.detail.order.remark': '备注',
	'app.crm.lead.detail.order.submit': '提交',
	'app.crm.lead.detail.order.success': '订单登记已提交(占位)',
	'app.crm.lead.detail.order.tip': '出单登记,请在详情页使用',
	'app.crm.lead.detail.createTitle': '新建线索',
	'app.crm.lead.detail.editTitle': '编辑线索',
	'app.crm.lead.detail.phoneMasked': '中间四位已脱敏',
	'app.crm.lead.detail.error.save': '保存失败',
	// 字段展示版(只读 schema 浏览器,挂在 CRM > 线索模板)
	'app.crm.lead.fields.title': '线索模板',
	'app.crm.lead.fields.empty': '暂无模板,请联系管理员配置',
	'app.crm.lead.fields.field.key': '字段标识',
	'app.crm.lead.fields.field.label': '显示名',
	'app.crm.lead.fields.field.module': '所属域',
	'app.crm.lead.fields.field.type': '类型',
	'app.crm.lead.fields.field.options': '枚举项',
	'app.crm.lead.fields.field.searchable': '可搜索',
	'app.crm.lead.fields.field.yes': '是',
	'app.crm.lead.fields.field.no': '否',
	'app.crm.lead.fields.error.load': '模板加载失败'
}
